<template>
  <v-row class="desposite-dashboadpage Liabilities-page account-dashboard">
    <v-col xs="12" md="12">
      <v-row class="head-box">
        <v-col xs="8" md="8">
            <ul class="breadcrumbs-list">
              <a  @click="backButton"><li>Accounts</li></a>
              <li>&nbsp;>&nbsp;Accounts Dashboard</li>
            </ul>
            <div class="head-text">
              <h1>Accounts Dashboard</h1>
            </div>
          </v-col>
          <v-col xs="4" md="4">
            <div class="right-sidetop-box">
              <div class="select-box">
                <v-card> 
                  <v-select
                    :items="member_items"
                    :v-model="member_name"
                    item-value="id"
                    item-text="name"
                    chips
                    label="All Users"
                    @change="refreshDashboard($event)"
                  ></v-select>
                </v-card>  
              </div>
              <div class="add-btn" v-if="allow_user_activity =='yes'">
                <v-btn class="orange-btn btn" @click="subCategory">
                  ADD NEW
                </v-btn>
              </div>  
            </div>
          </v-col>
      </v-row> 
      <AccountsTab />
    </v-col>  
   <!--  <v-col xs="4" md="4">
      
    </v-col>   -->
  </v-row>  
</template>
<script>
  import AccountsTab from './AccountsTab';
  import { POST_API, GET_API, UPDATE_USER_DETAILS, GET_ACCOUNTS_FORM_DETAIL} from "../../store/actions.type";
  import ApiService from "../../api/api.service";
  import { isEmpty } from 'lodash';
  export default {
    components: {
      AccountsTab,
    },
    data: () => ({
      member_items: [],
      member_name:'',
      three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
      edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
      delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
      currentDate: new Date().setDate(new Date().getDate()),
      total:'',
      allow_user_activity:localStorage.getItem('allow_user_activity')
    }), 
      mounted(){
       Fire.$on("updateLiabilityData", () => {
          this.getData();
        });
        if(!isEmpty(this.$store.getters.getAccountFormDetail)) {
          this.getData();
        }
      },
    methods:{
      getData(){
        this.member_items = [];
        let response = this.$store.getters.getAccountFormDetail;
        response.member_list.forEach(elementData => {
          this.member_items.push({'id':elementData.id,'name':elementData.name})
        });
      },
      refreshDashboard(event){
        this.$loading(true);
        this.memberId = event;
        let userData = [
          {key:'selected_value', value:event.toString()},
        ]
        this.$store.dispatch(UPDATE_USER_DETAILS,userData)
        let user_name =  this.$store.getters.getUserDetails.user_name;
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        this.$store
        .dispatch(GET_ACCOUNTS_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name: user_name,
            member_id:event,
          },
          api: "get-account-form-detail",
        })
        .then((response) => {
          Fire.$emit('updateLiabilityData');
          this.$loading(false);
        }).catch(() => {
          this.$loading(false);
        });
      },
      subCategory(){
         this.$router.push({ name: "accounts-subcategory"}).catch(()=>{});
      },
      backButton(){
        this.$router.push({ name: 'account'}).catch(()=>{});
      },
     
      
    } 
  }
</script>
